import {
  SchemaForm,
  type JsonSchema,
  type SchemaFormValue,
} from '@southfields-digital/mpxlive-components';
import { useCallback, useEffect, useState } from 'react';

type RuntimeFieldsFormProps = {
  schema: JsonSchema;
  initialValues?: SchemaFormValue;
  designTimeContext: SchemaFormValue;
  onChange: (values: SchemaFormValue) => void;
  isDisabled?: boolean;
};

export const RuntimeFieldsForm = ({
  schema,
  initialValues,
  designTimeContext,
  onChange,
  isDisabled = false,
}: RuntimeFieldsFormProps) => {
  const [localValues, setLocalValues] = useState<SchemaFormValue>(() => ({
    ...designTimeContext,
    ...initialValues,
  }));

  useEffect(() => {
    // Let prev win if designTimeContext or initialValues changes
    setLocalValues((prev) => ({
      ...designTimeContext,
      ...initialValues,
      ...prev,
    }));
  }, [designTimeContext, initialValues]);

  const handleChange = useCallback(
    (newValues: SchemaFormValue) => {
      if (isDisabled) return;

      setLocalValues(newValues);
      onChange(newValues);
    },
    [isDisabled, onChange]
  );

  return (
    <SchemaForm schema={schema} value={localValues} onChange={handleChange} disabled={isDisabled}>
      {/* Need this otherwise we render the submit button native to SchemaForm */}
      <></>
    </SchemaForm>
  );
};

export default RuntimeFieldsForm;
